import React from 'react';

import cn from 'classnames';
import styles from './NavigationTabs.module.scss';
import { Text } from 'components/core';

export const NavigationTabs = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode }
>(({ children }, ref) => {
  return (
    <div ref={ref} className={styles.tabsWrapper}>
      <div
        className={styles.tabsOuterWrapper}
        data-testid="secondary-navigation"
      >
        <div className={`${styles.statusBarContents}`}>{children}</div>
      </div>
    </div>
  );
});

NavigationTabs.displayName = 'NavigationTabs';

type NavigationTabItemProps = {
  name: string;
  count?: number;
  url: string;
  active?: boolean;
  countAriaLabel?: string;
  badge?: () => JSX.Element;
};

export const NavigationTabItem = (
  props: Omit<NavigationTabItemProps, 'badge'>
) => {
  return <NavigationTabItemWithBadge {...props} badge={undefined} />;
};

export const NavigationTabItemWithBadge = ({
  name,
  count,
  countAriaLabel,
  url,
  active,
  badge,
}: NavigationTabItemProps) => {
  const showCount = count || count === 0;
  return (
    <a
      href={url}
      aria-label={countAriaLabel}
      aria-current={active ? 'page' : undefined}
      className={cn(styles.tabItem, active && styles.tabActive)}
    >
      <Text
        component="span"
        size="md"
        variant={active ? 'primary' : 'neutral'}
        className={cn(styles.text, active && styles.activeText)}
      >
        {name}
        {showCount && (
          <Text component="span" size="md" variant="weak">
            {count}
          </Text>
        )}
      </Text>
      {badge && badge()}
    </a>
  );
};
